import { combineReducers } from 'redux';

import ppa from './common/ppa/reducer';
import settings from './common/settings/reducer';
import solar from './common/solar/reducer';
import tax from './common/tax/reducer';
import utility from './common/utility/reducer';
import loan from './common/loan/reducer';
import ess from './common/ess/reducer';
import sgip from './common/sgip/reducer';
import obs from './common/obs/reducer';
import projects from './common/projects/reducer';
import auth from './common/auth/reducer';
import smart from './common/smart/reducer';
import projectaddress from './common/projectaddress/reducer';
import cap from './common/cap/reducer';
import cash from './common/cash/reducer';
import nyserda from './common/nyserda/reducer';
import clientsReducer from './common/clients/reducer';
import projectstatus from './common/projectstatus/reducer';
import projectreps from './common/projectreps/reducer';


import inputsUI from './Inputs/reducer';
import isLockedUI from './IsLocked/reducer';
import ppaUI from './Inputs/PPA/reducer';
import loanUI from './Inputs/Loan/reducer';
import solarInputsUI from './Inputs/SolarInputs/reducer';
import taxInputsUI from './Inputs/TaxInputs/reducer';
import utilityInputsUI from './Inputs/UtilityInputs/reducer';
import resultsUI from './Simulator/TabBar/Results/reducer';
import essUI from './Inputs/ESS/reducer';
import sgipUI from './Inputs/SGIP/reducer';
import clientInfoUI from './AddClient/ClientInfo/reducer';
import contactUI from './AddClient/Contact/reducer';
import obsUI from './Inputs/OBS/reducer';
import signInUI from './Inputs/SignIn/reducer';
import createUI from './NewProject/reducer';
import smartUI from './Inputs/SMART/reducer';
import projectaddressUI from './Inputs/ProjectAddress/reducer';
import capUI from './Inputs/CAP/reducer';
import cashUI from './Inputs/CASH/reducer';
import nyserdaUI from './Inputs/NYSERDA/reducer';
import addClientUI from './AddClient/reducer';
import signOutUI from './Inputs/SignOut/reducer';
import projectStatusUI from './Inputs/ProjectStatus/reducer';


const rootReducer = combineReducers({
    auth,
    capUI,
    cap,
    obs,
    obsUI,
    clientInfoUI,
    contactUI,
    inputsUI,
    isLockedUI,
    ppa,
    ess,
    sgip,
    sgipUI,
    ppaUI,
    resultsUI,
    settings,
    solar,
    solarInputsUI,
    tax,
    taxInputsUI,
    utility,
    utilityInputsUI,
    loanUI,
    loan,
    essUI,
    signInUI,
    projects,
    createUI,
    smart,
    smartUI,
    projectaddressUI,
    projectaddress,
    cashUI,
    cash,
    nyserdaUI,
    nyserda,
    clientsReducer,
    addClientUI,
    signOutUI,
    projectstatus,
    projectStatusUI,
    projectreps,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/containers/rootReducer.js